import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface TokenLimitUpdateProps {
  tokenApprovalLimit: number;
}

export const useUpdateTokenLimit = (orgId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateTokenLimit = async (data: TokenLimitUpdateProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/org/${orgId ? `${orgId}/` : ''}token-limit`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update credit limit');
    }
  };

  return useMutation({
    mutationFn: updateTokenLimit,
    onSuccess: () => {
      queryClient.invalidateQueries(orgId ? [QueryEntity.OrganisationById, { orgId }] : [QueryEntity.OrganisationById]);
    },
  });
};
